import axios from "axios";
const {REACT_APP_API_URL} = process.env;

//Configuración de los servicios de axios, dicha configuración es llamada en las sagas
export const  authSaga = async (data) => {
  const { email, password } = data;

  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/api/login`,
    data: {
      username: email,
      password: password,
    },
  })
    .then((response) => response.data)
    .catch((err) => {
      const serverMessage = err?.response?.data?.msg;
      const status = err?.response?.status;

      if (serverMessage) {
        return { msg: serverMessage };
      }

      if (status === 401) {
        return { msg: "Correo o contraseña incorrectos" };
      }

      if (!err?.response) {
        return { msg: "No se pudo conectar al servidor de autenticación" };
      }

      return { msg: "No fue posible iniciar sesión" };
    });
};

export const authMicrosoftSaga = async (data) => {
  const { username, nombres, apellidos, correo, ci, jefe_directo, cargo } = data;

  return axios({
    method: "post",
    url: `${REACT_APP_API_URL}/api/login/microsoft`,
    data: {
      username,
      nombres,
      apellidos,
      correo,
      ci,
      jefe_directo,
      cargo,
    },
  })
    .then((response) => response.data)
    .catch((err) => {
      const serverMessage = err?.response?.data?.msg;
      const status = err?.response?.status;

      if (serverMessage) {
        return { msg: serverMessage };
      }

      if (status === 401) {
        return { msg: "No autorizado" };
      }

      if (!err?.response) {
        return { msg: "No se pudo conectar al servidor de autenticación" };
      }

      return { msg: "No fue posible iniciar sesión con Microsoft" };
    });
};
